import React, {Component} from "react";
import config from 'react-global-configuration';

class AxisATPFilter extends Component {
    state = {
        axis_atp: false,
    };
    componentDidMount(){

    }
    resetAxisAtpFilter() {
        this.setState({
            axis_atp: 0,
        })
    }

    handleCheckSKU(e){
        var axis_atp = 1;
        if (e.target.checked === true) {
            this.setState({axis_atp: 1})
        } else {
            this.setState({axis_atp: 0});
            axis_atp = 0;
        }
        this.props.onSelectAxisAtp(axis_atp);
    }
    render() {
        return (
        <label>
            <input type="checkbox" name="axis_atp" onChange={this.handleCheckSKU.bind(this)}
            checked={(this.state.axis_atp == 1) ? true : false}/> &nbsp;  Aggregation </label>
        );

    }
}
export default AxisATPFilter;